import { render, staticRenderFns } from "./OrganCourseInfoView.vue?vue&type=template&id=311b13a0&scoped=true"
import script from "./OrganCourseInfoView.vue?vue&type=script&lang=js"
export * from "./OrganCourseInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b13a0",
  null
  
)

export default component.exports